/**
 * KBDbArticlePage — мінімальний рендер мігрованих з 1.0 статей `know_base`.
 *
 * На відміну від KBArticle.tsx (статичні telegra.ph з повним AST-рендером),
 * ці статті містять plain text / простий HTML (`<b>`, `<i>`, переноси
 * рядків) — рендеримо через sanitizeHtml + whitespace-pre-wrap.
 *
 * Юзер 2026-05-23: «зараз вже у нас все статті інтегровано прямо
 * в мініапку» — статичні; ця сторінка для майбутніх 18 admin-статей
 * що мігрують з 1.0 SQLite `know_base`.
 */

import { useParams } from "react-router-dom";
import { BackNav } from "@/components/BackNav";
import { ArticleBottomNav } from "@/components/ArticleBottomNav";
import { Spinner } from "@/components/Spinner";
import { sanitizeHtml } from "@/lib/sanitize";
import { openExternalOnAnchorClick } from "@/lib/openExternal";
import { useKBDbArticle } from "@/api/hooks";
import { FounderInstagramCard } from "@/components/FounderInstagramCard";

export function KBDbArticlePage() {
  const { id } = useParams<{ id: string }>();
  const q = useKBDbArticle(id);

  return (
    <>
      <BackNav to="/knowledge-base" backLabel="База знань" showMenu />
      {q.isLoading && (
        <div className="py-8 flex justify-center">
          <Spinner />
        </div>
      )}
      {q.isError && (
        <div className="px-4 py-8 text-center text-ink-dim">
          Не вдалось завантажити статтю.
        </div>
      )}
      {q.data && (
        <article className="px-1 pb-12">
          <h1
            className="mb-4 font-display font-bold text-ink"
            style={{ fontSize: "1.625rem", lineHeight: 1.2, letterSpacing: "-0.02em" }}
          >
            {q.data.title}
          </h1>
          {q.data.photo_file_id && (
            <div className="mb-4 text-[0.6875rem] text-ink-dim italic">
              {/* Telegram file_id — Mini App не може напряму показати photo
                  через TG API; залишаємо як hint що в оригіналі було фото.
                  Майбутній admin-tool зможе перевантажити в Cloud Storage. */}
              [фото з 1.0]
            </div>
          )}
          <div
            className="text-[0.9375rem] leading-relaxed text-ink whitespace-pre-wrap [&_b]:font-semibold [&_strong]:font-semibold [&_i]:italic [&_em]:italic [&_a]:text-primary [&_a]:underline"
            onClick={openExternalOnAnchorClick}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(q.data.content) }}
          />
          <div className="mt-6">
            <FounderInstagramCard />
          </div>
          {/* Низ статті: Назад (до бази знань) + Меню (юзер 2026-06-25) */}
          <ArticleBottomNav backTo="/knowledge-base" backLabel="База знань" />
        </article>
      )}
    </>
  );
}
